import styled from "@emotion/styled"
import { Box, Flex } from "@rebass/grid/emotion"
import theme from "@nutrafol/nutrafol-ui-kit/styles/theme"
export const BadgeContainer = styled(Box)``

export const BenefitsFlex = styled(Flex)`
  flex-direction: column;
  align-items: center;
  position: relative;
  @media (min-width: 1280px) {
    align-items: self-start;
    min-height: 175px;
  }
`

export const BenefitsRow = styled(Flex)`
  flex-direction: row;
  text-align: center;
  width: 100%;
  align-items: center;

  &:not(:last-of-type) {
    padding: 0 0 16px;
  }

  @media (min-width: 768px) {
  }
  @media (min-width: 1280px) {
    //padding: 0 0 16px;
    border-bottom: none;
    text-align: left;
  }
`

export const HeroDivider = styled(Box)`
  position: absolute;
  top: 0;
  bottom: 0;
  left: calc(50% - 1px);
  width: 2px;
  background: ${theme.wild.color.nova.transparency.black[20]};
  z-index: -2;

  @media (min-width: 1280px) {
    z-index: 0;
    height: 0;
    top: 0;

    &.vertical-playing {
      &:after {
        content: "";
        position: absolute;
        top: 100%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background: #ffc942;
      }
    }
  }
`

export const HeroDividerHorizontal = styled(Box)`
  position: absolute;
  z-index: -1;
  top: calc(50% - 1px);
  left: 50%;
  max-width: 960px;
  height: 2px;
  background: ${theme.wild.color.nova.transparency.black[20]};
  @media (min-width: 1280px) {
    &.vertical-finished {
      &:after {
        content: "";
        position: absolute;
        top: 50%;
        left: 100%;
        transform: translate(-50%, -50%);
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background: #ffc942;
      }
    }
  }
`

export const HeroDot = styled(Box)`
  position: absolute;
  top: -4px;
  left: calc(50% - 4px);
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #ffc942;
  z-index: -1;
  //see height clamp in src/components/wild/nova/hero/hero.desktop.js
  // take half of the pill box whitespace and add dot size
  @media (min-width: 1280px) {
    top: -4px;
    z-index: 1;
  }
`

export const HeroContainerWrapper = styled(Box)`
  background: linear-gradient(to bottom, white 50%, rgba(236, 241, 245, 1) 60%);
  padding-top: 100px;

  @media (min-width: 768px) {
    padding-top: 124px;
  }

  @media (min-width: 1024px) {
    padding-top: 148px;
  }

  @media (min-width: 1280px) {
    background: linear-gradient(
      to bottom,
      white 40%,
      rgba(236, 241, 245, 1) 50%
    );
  }

  .mx-lg {
    margin-right: auto;
    margin-left: auto;

    @media (min-width: 1280px) {
      margin-left: 0;
      margin-right: 0;
    }
  }
`

export const HeroContainer = styled(Box)`
  width: 100%;
  max-width: 1600px;
  padding-left: 16px;
  padding-right: 16px;
  margin-left: auto;
  margin-right: auto;

  @media (min-width: 768px) {
    padding-left: 40px;
    padding-right: 40px;
  }

  @media (min-width: 1470px) {
    padding-left: 0;
    padding-right: 0;
  }
`

export const HeroContainerMobile = styled(Box)`
  @media (min-width: 1280px) {
    display: none;
  }
`

export const HeroContainerDesktop = styled(Flex)`
  @media (max-width: 1279px) {
    display: none;
  }
  //transform: translateY(-2%);

  //transition: transform 0.5s ease-in-out; /* Smooth transition */
  @media (min-height: 820px) {
    transform: none;
  }
  .top-flex {
    align-items: flex-end;
    //background: orange;
  }
`

export const HeroDesktopLeft = styled(Flex)`
  flex-direction: column;
  min-height: 1634px;
  width: 100%;

  .left-trigger {
    //background: red;
  }
`

export const HeroDesktopRight = styled(Flex)`
  flex-direction: column;
  min-height: 1634px;
  width: 100%;

  .top-flex-right {
    padding-bottom: 60px;
  }
`

export const TabTransition = styled(Box)`
  transition: transform 0.5s ease;
  z-index: 1;
  &.tab-balance {
    transform: translateY(0);
  }

  &.tab-women {
    transform: translateY(64px);
  }

  &.tab-postpartum {
    transform: translateY(-64px);
  }
`

export const HeroDesktopRightFlex = styled(Flex)`
  flex-direction: row;
  align-items: center;
  padding-right: 0;

  .benefits {
    padding-right: 48px;
    max-width: 469px;
    box-sizing: content-box;
  }

  @media (min-width: 1470px) {
    padding-right: 112px;
  }
`

export const ContainerWithBg = styled(Box)`
  z-index: 1;
  position: relative;
  .bg-filter {
    position: relative;

    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 50%;
      width: 8px;
      height: 100%;
      background: white;
      transform: translateX(-50%);
      z-index: -1;
    }

    &.filter-two {
      &::before {
        background: linear-gradient(#ffffff, #f4f6f9);
        @media (min-width: 800px) {
          background: linear-gradient(#f8f9fb, #eff3f6);
        }
        @media (min-width: 1024px) {
          background: linear-gradient(#f8f9fb, #ecf1f5);
        }
      }
    }

    &.filter-three {
      &::before {
        background: linear-gradient(#ecf1f5, #ecf1f4);
        @media (min-width: 800px) {
          background: linear-gradient(#ecf1f4, #ecf1f5);
        }
        @media (min-width: 1024px) {
          background: linear-gradient(#ecf1f5, #ecf1f5);
        }
        @media (min-width: 1280px) {
          background: #ecf1f5;
        }
      }
    }
  }
  .image-wrapper {
    transform: scale(0);
    position: relative;
    width: 216px;
    height: 216px;
    // cover vertical line on images transition
    background: linear-gradient(
      to right,
      transparent 160px,
      rgba(236, 241, 245, 0.1) 161px,
      rgba(236, 241, 245, 0.1) 180px,
      transparent 181px
    );
    @media (min-width: 768px) {
      width: 340px;
      height: 340px;
    }
    @media (min-width: 1280px) {
      width: 360px;
      height: 360px;
      background: rgba(236, 241, 245, 1);
    }

    img {
      //border: 1px red dotted;
      position: absolute;
      width: inherit;
      height: inherit;
      object-fit: cover;
      opacity: 0;
    }
  }

  //hide right arrow on mobile

  .right {
    @media (max-width: 767px) {
      display: none;
    }
  }
`

export const ButtonsContainer = styled(Flex)`
  justify-content: center;

  gap: 4px;

  a {
    min-width: 154px;
  }

  @media (min-width: 768px) {
    gap: 8px;
    a {
      min-width: 143px;
    }
  }

  @media (min-width: 1024px) {
    a {
      min-width: 154px;
    }
  }

  @media (min-width: 1280px) {
    justify-content: flex-start;
    gap: 16px;
    a {
      min-width: 167px;
    }
  }
`
